import { RAW_cssValue, ThemeUIStyleObject } from "@classdojo/web/nessie/stylingLib";

type TimeInputProps = {
  value: number;
  selected: boolean;
  onFocus: VoidFunction;
  onChange: (input: number) => void;
};

export default function TimeInput({ value, selected, onFocus, onChange }: TimeInputProps) {
  return (
    <input
      type="number"
      value={value < 10 ? `0${value}` : value.toString().trim()}
      onChange={(e) => {
        if (Number(e.target.value) > 99) return false;
        onChange(Number(e.target.value));
      }}
      onFocus={onFocus}
      sx={timeInputStyle(selected)}
      autoFocus
    />
  );
}

const timeInputStyle = (selected: boolean): ThemeUIStyleObject => ({
  border: "none",
  fontSize: 60,
  fontWeight: 800,
  color: selected ? "dt_content_accent" : "dt_content_primary",
  width: 110,
  textAlign: "center",
  outline: "none",
  padding: RAW_cssValue("10px"),
});
